import { ComponentProps } from 'react'
import styled from 'styled-components'

import { Dropdown, TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'

import { FavoritesButton } from '../../../../../../app/_components/buttons/FavoritesButton.client'
import { useFavorites } from '../../../../../../app/_providers/FavoritesProvider.client'

export const ProductDetailsTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1.45;
  text-transform: uppercase;
`

export const IntlMsgWrap = styled(ProductDetailsTitle)`
  text-align: center;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(4)} 0;
  }
`

export const ProductDetailsCopy = styled.blockquote<{
  secondary?: boolean
}>`
  ${TypeStyle.css.headlineMicro}
  color: ${o => o.secondary && o.theme.color.deprecated.obsidianLighter};
  padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
`

export const PromoExclusionMessage = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(6)} 0;
  }
`

export const QuantitySelectorWrapper = styled.div`
  margin-right: 8px;
`

export const StyledDropdown = styled(Dropdown)`
  height: 100%;

  > [role='button'] {
    box-sizing: border-box;
    height: 100%;
  }
`

export const WhyWeLoveDivider = styled.hr`
  border-color: ${o => o.theme.color.deprecated.stoneLight};
  border-style: solid;
  border-width: 1px 0 0;
  margin: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
`

export const WhyWeLoveText = styled(TypeStyle.HeadlineExtraExtraSmall)`
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  font-weight: 400;
  padding: 24px 0;
`

export const PDPFavoritesButtonContainer = styled(
  (props: { children?: React.ReactNode; className?: string }) => {
    const { status } = useFavorites()
    if (status === 'rejected') return null
    return <div className={props.className}>{props.children}</div>
  }
)`
  border: 1px solid #cccccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;

  > * {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
  }
`

export const PDPFavoritesButton = ({
  iconWidth = '18px',
  ...rest
}: ComponentProps<typeof FavoritesButton>) => {
  return <FavoritesButton iconWidth={iconWidth} {...rest} />
}

export const ErrorMessageContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};

  ${untilMd} {
    margin-top: ${({ theme }) => theme.spacing(4)};
    padding: ${({ theme }) => theme.spacing(0, 4, 0)};
  }
`
